import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import CacheBuster from "../utils/cacheBuster";
import React, {useEffect} from "react";
import * as actions from "../store/actions";
import api from "../store/api/api";
import {useDispatch, useSelector} from "react-redux";
import {useUser} from "./auth";
import AnonTemplate from "../components/templates/AnonTemplate";
import {setCampaignList, setMemberships} from "../store/actions";

export default function Root() {

    const focusedCampaign = useSelector(state => state.session.focusedCampaign);
    const permissions = useSelector(state => state.permissions);
    const dispatch = useDispatch();
    const me = useUser();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (me) {
            console.log('me', me)
            dispatch(actions.setAccessToken("obsoletetoken"));
            dispatch(actions.setRefreshToken("obsoletetoken"));
            if (permissions.loading) {
                api.get("myaccount/").then((res) => {
                    console.log('pass to redux', res.data)
                    const { memberships, ...account } = res.data;
                    const campaigns = {};
                    memberships.forEach(membership => {
                        if (membership.campaign.is_active || membership.role.name === 'admin') {
                            campaigns[membership.id] = membership.campaign;
                        }
                    });
                    dispatch(setCampaignList(Object.values(campaigns)));
                    dispatch(setMemberships(memberships, account.profile));
                    if (location.pathname === '/startup') {
                        navigate('/select-campaign');
                    }
                })
            } else if (location.pathname === '/') {
                if (!focusedCampaign || !focusedCampaign.id) {
                    navigate('/select-campaign');
                } else if (permissions.memberships && permissions.memberships.length > 0 && focusedCampaign) {
                    navigate('/dash');
                } else {
                    navigate('/select-campaign');
                }
            } else if (!focusedCampaign || !focusedCampaign.id) {
                navigate('/select-campaign');
            }
        }
    }, [me, focusedCampaign, permissions])

    const Wrapper = !me ? AnonTemplate : React.Fragment;

    return (
        <Wrapper>
            <CacheBuster/>
            <Outlet />
        </Wrapper>
    )
}
